import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Apartment } from './../models/apartment.model';
import { environment } from '../../../environments/environment';

/**
 * Service to use the API apartments related calls.
 */
@Injectable()
export class ApartmentService {
  /**
   * Build the component and initialize certain attributes.
   * @param {HttpClient} http Service to make API calls.
   */
  constructor(private http: HttpClient) {}

  /**
   * Sends an apartment to store it in the backend.
   * @param {Apartment} data Apartment to be stored.
   */
  create(data: Apartment) {
    return this.http.post(`${environment.apiUrl}/apartments`, data);
  }
  /**
   * Updates an apartment in the backend.
   * @param {string} id Apartment ID.
   * @param {Apartment} data Apartment to be updated.
   */
  update(id: string, data: Apartment) {
    return this.http.put(`${environment.apiUrl}/apartments/${id}`, data);
  }
  /**
   * Deletes an apartment in the backend.
   * @param {string} id Apartment ID.
   */
  delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/apartments/${id}`);
  }
  /**
   * Gets one Apartment from the backend.
   * @param {string} id Apartment ID.
   */
  show(id: string) {
    return this.http.get(`${environment.apiUrl}/apartments/${id}`);
  }
  /**
   * Gets apartments filtering by certain parameters.
   * @param params Parameters to filter the query.
   */
  showAll(params: any = {}) {
    return this.http.get(`${environment.apiUrl}/apartments`, {
      params: params
    });
  }
}
